function calculateAmount(data) {
    console.log("Calculate Amount");
    console.log(data);

    var totalAmount = 0;
    var iScheingebuehren = 0;
    var dataDurationIndex = data.duration;

    if(data.lottoReihen || data.reihenSysteme) {

        if(data.reihenSysteme) {
            for (var sSystem in data.reihenSysteme) {
                totalAmount += gebuehrenMatrix[data.reihenSysteme[sSystem]].Betrag
            }
        } else {
            totalAmount += gebuehrenMatrix["006"].Betrag * data.lottoReihen;
            console.log("TotalAmount Reihen: " + totalAmount);
        }

        if(data.super6) {
            console.log("Betrag Spiel S6: " + gebuehrenMatrix.S6.Betrag);
            totalAmount += gebuehrenMatrix.S6.Betrag;
        }

        if(data.spiel77) {
            console.log("Betrag Spiel 77: " + gebuehrenMatrix.S77.Betrag);
            totalAmount += gebuehrenMatrix.S77.Betrag;
        }

        if(data.drawingDays.toLowerCase() == "k") {
            totalAmount *= 2;
        }

        if((typeof calculateScheinGebuehr !== 'undefined') && calculateScheinGebuehr == 1) {
            console.log("Berechne Gebuehren fuer: " + data.SpielscheinTypId)
            // Normalschein
            if(data.SpielscheinTypId == 1) {
                console.log("Normalschein Gebuehr");
                if(feeMatrix.gebuehrenNormal[data.drawingDays][dataDurationIndex] != null) {
                    console.log("Gebühren Normalschein addieren");
                    console.log(feeMatrix.gebuehrenNormal[data.drawingDays]);
                    iScheingebuehren = feeMatrix.gebuehrenNormal[data.drawingDays][dataDurationIndex];
                    console.log("-> Lotto Scheingebuehr: " + iScheingebuehren);
                }
            }

            // Vollsystem
            if(data.SpielscheinTypId == 2) {
                console.log("Vollsystem Gebuehr");
                if(feeMatrix.gebuehrenVollsystem[data.drawingDays][dataDurationIndex] != null) {
                    console.log(feeMatrix.gebuehrenVollsystem[data.drawingDays]);
                    iScheingebuehren = feeMatrix.gebuehrenVollsystem[data.drawingDays][dataDurationIndex];
                    console.log("-> Vollsystem Scheingebuehr: " + iScheingebuehren);
                }
            }
            // Teilsystem
            if(data.SpielscheinTypId == 3) {
                console.log("Teilsystem Gebuehr");
                if(feeMatrix.gebuehrenTeilsystem[data.drawingDays][dataDurationIndex] != null) {
                    console.log(feeMatrix.gebuehrenTeilsystem[data.drawingDays]);
                    iScheingebuehren = feeMatrix.gebuehrenTeilsystem[data.drawingDays][dataDurationIndex];
                    console.log("-> Teilsystem Scheingebuehr: " + iScheingebuehren);
                }
            }
            // Kombischein
            if(data.SpielscheinTypId == 4) {
                console.log("Kombischein Gebuehr");
                if(feeMatrix.gebuehrenKombiSchein[data.drawingDays][dataDurationIndex] != null) {
                    console.log(feeMatrix.gebuehrenKombiSchein[data.drawingDays]);
                    iScheingebuehren = feeMatrix.gebuehrenKombiSchein[data.drawingDays][dataDurationIndex];
                    console.log("-> Komboschein Scheingebuehr: " + iScheingebuehren);
                }
            }
        }

        totalAmount = (totalAmount*data.duration) + iScheingebuehren;

    } else if (data.eurojackpotReihen) {
        var iGebuehren = 0;

        if((typeof calculateScheinGebuehr !== 'undefined') && calculateScheinGebuehr == 1) {
            console.log("Calculate Scheingebuehr Eurojackpot ");
            if(feeMatrix["gebuehrenEurojackpot"][data.drawingDays][dataDurationIndex] != null) {
                iGebuehren = feeMatrix["gebuehrenEurojackpot"][data.drawingDays][dataDurationIndex];
                console.log("-> Eurojackpot Scheingebuehr: " + iScheingebuehren);
            }
        }

        var totalAmount = data.eurojackpotReihen *  gebuehrenMatrix["E05"].Betrag;

        if(data.drawingDays.toLowerCase() == "k") {
            totalAmount *= 2;
        }

        totalAmount = (totalAmount * data.duration) + iGebuehren;
    }

    totalAmount = (totalAmount / 100).toFixed(2).replace(".", ",") + "&nbsp;€";

    return totalAmount;
}